module.exports = __webpack_public_path__ + "static/media/pic_add_membership_screenshot.3c5f1787.jpg";